<template>
  <template v-if="isRequiredOrientation">
    <slot></slot>
  </template>
</template>

<script setup>
import { computed } from "vue";
import { useScreenOrientation } from "@vueuse/core";

const props = defineProps([
  "value"
]);

const { orientation } = useScreenOrientation();

const isRequiredOrientation = computed(() => {
  if (props.value == "portrait")
    return orientation.value.includes("portrait");
  if (props.value == "landscape")
    return orientation.value.includes("landscape");
});
</script>